import { BookingStatusEnum } from "src/app/shared/models/booking-status.enum";
import { BookingBase } from "./booking-base";
import { PromoCodeDiscountType } from "src/app/shared/models/promo-code-discount-type.enum";

export class BookingSchedule extends BookingBase {
    public startTime: Date;
    public endTime: Date;
    public simulatorId: string;
    public bayName: string;
    public bayNumber: string;
    public status: BookingStatusEnum;
    public confirmationNumber: string;
    public descriptionString: string;
    public phoneNumber: string;
    public email: string;
    public customerName: string;
    public participants: number;
    public priceOverride: number;
    public priceOverrideReason: string;
    public hasPaid: boolean;
    public duration: number;
    public totalPrice: number;
    public addons: any[];
    public promoCodeId: string;
    public code: string;
    public discountType: PromoCodeDiscountType;
    public discountAmount: number;
    public stripePaymentIntentId: string;
    public membershipCustomerId: string;
    public discountCode: string;
    public scheduledBookingId: string;
}
